export { default, defaultState } from './fetchAuthStatus'